(
    function (skyward, $, undefined)
    {
        skyward.homelanguagesurveywi = skyward.homelanguagesurveywi || {};

        var init = function (selector)
        {
            if ($(selector).find('.hlsQuestionWI').length == 0)
            {
                return;
            }

            $(selector).find(".hlsQuestionWI").find("input:radio").on("click", function ()
            {
                var radioGroup = $(this).closest('.radioButtonGroup');
                var hiddenRadioButton = radioGroup.find("input:radio:hidden");
                if ($(this).val() == skyward.controls.getValue(radioGroup) && hiddenRadioButton.length == 1)
                {
                    skyward.controls.setValue(radioGroup, hiddenRadioButton.val());
                }
            });
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
